const getBestTypedImageUrl = (urls: any[], keyName: string) => {
	const typesInPriority = [
		"Original",
		"Thumbnail",
		"Front",
		"3000",
		"2500",
		"2000",
		"1500",
		"1300",
		"1100",
		"900",
		"160",
		"75",
		"Top",
	];

	// Store the full object, not just a string
	const typeToUrlMap: Record<string, any> = {};
	urls?.forEach((url) => {
		typesInPriority.find((type) => {
			if (
				url[keyName]?.sourceUrl?.includes(`/${type}/`) &&
				!url[keyName]?.sourceUrl?.includes(`Manufacturer`)
			) {
				typeToUrlMap[type] = url[keyName];
				return true;
			}
		});
	});

	const sortedUrls = typesInPriority
		.map((type) => typeToUrlMap[type])
		.filter((url) => !!url);
	return sortedUrls[0] || null;
};

const getImageSrc = (images: any, placeholder: string): string => {
	const bestImageSrc = getBestTypedImageUrl(images, "thumbnailImage") || {};
 	const imageUrl = bestImageSrc?.sourceUrl || placeholder;

	return imageUrl;
};

export default getImageSrc;
